import { defineMeta } from '@/registry/types';

export const timePickerMeta = defineMeta({
  name: 'TimePicker',
  level: 'molecule',
  category: 'input',
  classification: 'themed-mui',
  description: 'Clock-based time selection. Themed MUI X TimePicker (dayjs).',
  baseLibrary: '@mui/x-date-pickers',
  muiEquivalent: 'TimePicker',
  muiDocs: 'https://mui.com/x/react-date-pickers/time-picker/',
  a2uiEquivalent: 'TimePicker',
  importPath: '@/molecules/TimePicker',
  optionalProps: ['value', 'defaultValue', 'disabled', 'ampm', 'onChange'],
  supportedStates: ['default', 'open', 'disabled'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Provide a visible label; keyboard operable.'],
  usageExamples: ['<TimePicker label="Start" value={t} onChange={set} />'],
  antiPatterns: ['Do not use for durations (use a duration input).'],
  llmSafe: true,
  whenToUse: ['Selecting a time of day'],
  whenNotToUse: ['Dates (use DatePicker)'],
});

export default timePickerMeta;
